import { Mode } from './../../enums';
import { getSegmentValues } from './get-segment-value';
export const hasAndValue = (view, value, segment) => {
    const values = getSegmentValues(view, segment, Mode.AND);
    return !!~values.indexOf(value);
};
